var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlackspotsUnknown = function SvgBlackspotsUnknown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.098,
    r: 9,
    stroke: "#000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.786 9.27c.256-.632.646-1.118 1.17-1.458.528-.34 1.156-.51 1.884-.51.56 0 1.056.092 1.488.276.436.18.772.426 1.008.738.24.308.36.65.36 1.026 0 .308-.054.584-.162.828a2.52 2.52 0 0 1-.396.636 9.258 9.258 0 0 1-.63.63 9.2 9.2 0 0 0-.6.606 2.318 2.318 0 0 0-.378.582c-.1.224-.15.478-.15.762h-1.41c0-.392.056-.742.168-1.05.116-.308.254-.57.414-.786a8.95 8.95 0 0 1 .624-.738c.18-.196.32-.358.42-.486.104-.128.19-.266.258-.414.068-.152.102-.312.102-.48a.814.814 0 0 0-.318-.672c-.212-.172-.482-.258-.81-.258a1.55 1.55 0 0 0-.924.312 1.753 1.753 0 0 0-.63.816zm3.846 6.828h-1.92v-1.872h1.92z"
  })));
};
export default SvgBlackspotsUnknown;